import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ManagementCompanyUser =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ManagementCompanyUser, _BaseData);

  function ManagementCompanyUser() {
    _classCallCheck(this, ManagementCompanyUser);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManagementCompanyUser).call(this, "ManagementCompanyUser"));
  }

  _createClass(ManagementCompanyUser, [{
    key: "GetMyManagementCompanies",
    value: function () {
      var _GetMyManagementCompanies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetMyManagementCompanies")));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetMyManagementCompanies() {
        return _GetMyManagementCompanies.apply(this, arguments);
      }

      return GetMyManagementCompanies;
    }()
  }, {
    key: "GetUserMcAdminRows",
    value: function () {
      var _GetUserMcAdminRows = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(userId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetUserMcAdminRows/").concat(userId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetUserMcAdminRows(_x) {
        return _GetUserMcAdminRows.apply(this, arguments);
      }

      return GetUserMcAdminRows;
    }()
  }, {
    key: "SavePermissions",
    value: function () {
      var _SavePermissions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(userId, managementCompanyIds) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("/api/".concat(this._controller, "/SavePermissions/").concat(userId), managementCompanyIds));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function SavePermissions(_x2, _x3) {
        return _SavePermissions.apply(this, arguments);
      }

      return SavePermissions;
    }()
  }]);

  return ManagementCompanyUser;
}(BaseData);

export default new ManagementCompanyUser();